import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import AppAdmin from './AppAdmin';
import AppMarchand from './AppMarchand';
import {ENV} from './config/globales';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    {(ENV==="marchand") && <AppMarchand />}
    {(ENV==="admin") && <AppAdmin />}
    {(ENV==="default" || ENV==="normal") && <App />}
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
